


































import Vue from 'vue'

export default Vue.extend({
	props: {
		message: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			conversations: null as Array<any>|null,
			sending: [] as Array<any>,
		}
	},
	mounted() {
		this.$axios.get('/api/chat/conversations').then((resp) => {
			this.conversations = []
			resp.data.conversations.forEach((conv: any) => {
				conv.sending = false
				conv.sent = false

				if (this.conversations) {
					this.conversations.push(conv)
				}
			})
		})
	},
	methods: {
		sendToConversation(conversation: any) {
			if (conversation.sending || conversation.sent) {
				return
			}

			conversation.sending = true

			this.$axios.post(
				conversation.type === 'group'
					? `/api/chat/group/${conversation.id}/message`
					: `/api/chat/with/${conversation.conversation_partner.id}/message`,
				{ text: this.message },
			).then(() => {
				conversation.sent = true
			}).catch(() => {
				this.$nuxt.$emit('showToastMessage', {
					message: 'An error occurred while sending your message.',
					duration: 3000,
				})
			}).finally(() => {
				conversation.sending = false
			})
		},
	},
})
